// ##### 24-05-10 Komarov
import moment from 'moment';
// ##### Komarov 2025-07-12
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import dateFormats from '../../../../../helpers/dateFormats';
import { setSearchClicked } from '../../../../../Redux/actions';
import { makeParamsString } from '../../../Helpers/helper';
// ##### 25-05-21 Komarov
import PromoCode from '../PromoCode';
// ##### 24-12-27 Komarov
import { encryptString } from '../../../../../helpers/crypto';

// ##### Komarov 2025-07-14
const BorderInnerWrapper2DivTag = ({ width = 'unset' }) => {
  // ##### 25-05-10 Komarov
  const language = useSelector(state => state.language);
  // ##### Komarov 2025-07-12
  useEffect(() => {
    moment.locale(language);
  }, [language]);
  // ##### Komarov 2025-08-05
  const Search = useSelector(state => state.pagesRedux[state.language]?.Search || '');

  const formFilled = useSelector(state => state.hotelsContext.formFilled);
  const hotelsvalue = useSelector(state => state.hotelsContext.hotelsvalue);
  const stayStartDate = useSelector(state => state.hotelsContext.stayStartDate);
  const stayEndDate = useSelector(state => state.hotelsContext.stayEndDate);
  const selectedItemInfo = useSelector(
    state => state.hotelsContext.selectedItemInfo
  );
  const totalPaxRedux = useSelector(state => state.paxchoice.pax);
  const locale = useSelector(state => state.language);
  const whitelabel = useSelector(state => state.whitelabel);
  const promoCode = useSelector(state => state.promocode.promocode);
  const isWhiteLabelSet = whitelabel.set;
  const company_cipher = whitelabel.company_cipher;
  const [list, setList] = useState([]);

  const pickedcurrencyFromState = useSelector(
    state => state.currency.pickedcurrency
  );
  // ##### 23-11-23 Komarov: TODO: разобраться, нужно ли устанавливать значение валюты из query (URL, на который обратились, - при поиске с определёнными параметрами происходит обращение на URL с такими параметрами)
  // ##### 24-07-25 Komarov
  const pickedcurrency =
    pickedcurrencyFromState ||
    JSON.parse(localStorage.getItem('currency')).pickedcurrency;

  const dispatch = useDispatch();

  const history = useHistory();
  // ##### Komarov 2025-08-02
  const shouldCypherUrlParams = useSelector(
    state => state.siteCypherCodeData.isDataEncrypted
  );

  const addToList = () => {
    // ##### 23-12-11 Komarov
    dispatch(setSearchClicked(true));
    if (!formFilled) {
      return;
    }

    // ##### 25-03-12 Komarov
    const id = localStorage.getItem('hotel_id');

    // ##### 25-03-12 Komarov
    const hotelNewList = {
      // id: filteredHotels[0].id,
      // ##### 25-04-21 Komarov
      id, // hotel's id
      title: hotelsvalue,
      // ##### 23-02-25 Komarov
      // date: stayDates
      date: [stayStartDate, stayEndDate],
    };

    setList([...list, hotelNewList]);

    const params_string = makeParamsString({
      selected_currency: pickedcurrency,
      title: hotelsvalue,
      start:
        (moment(stayStartDate, dateFormats[locale]).isValid() &&
          moment(stayStartDate, dateFormats[locale]).format(dateFormats.en)) ||
        moment(stayStartDate, dateFormats.en).format(dateFormats.en),
      end:
        (moment(stayEndDate, dateFormats[locale]).isValid() &&
          moment(stayEndDate, dateFormats[locale]).format(dateFormats.en)) ||
        moment(stayEndDate, dateFormats.en).format(dateFormats.en),
      id: (!!parseInt(localStorage.getItem('isCitySelected')) && '0') || id, // hotel's id
      city_id: localStorage.getItem('city_id'),
      adults: totalPaxRedux.adults,
      children: totalPaxRedux.children,
      rooms: totalPaxRedux.rooms,
    });

    // ##### 24-04-05 Komarov
    localStorage.setItem('selectedItemInfo', JSON.stringify(selectedItemInfo));
    // ##### 24-12-27 Komarov
    const route_query = `?${shouldCypherUrlParams ? encryptString(params_string) : params_string}`;

    // ##### 24-02-29 Komarov: TODO: Убрать промокод из URL
    if (isWhiteLabelSet) {
      history.push(
        `/${locale}/ref${company_cipher}/search_results_hotels/${route_query}`,
        [...list, hotelNewList]
      );
    } else if (promoCode) {
      history.push(`/${locale}/search_results_hotels/${route_query}`, [
        ...list,
        hotelNewList,
      ]);
    } else {
      history.push(`/${locale}/search_results_hotels/${route_query}`, [
        ...list,
        hotelNewList,
      ]);
    }
  };

  return (
    <div
      className="borderInnerWrapper2"
      data-component="BorderInnerWrapper2DivTag"
    >
      <div
        style={{
          display: 'flex',
          width,
        }}
      >
        <div className="promocode_mobile">
          {/* ##### 24-08-05 Komarov */}
          {/* TODO: Исправить код с учётом различия понятий refpartner и promoCode */}
          <PromoCode /* refpartner={searchProps ? searchProps.refpartner : ""} */
          />
        </div>

        <button type="submit" onClick={addToList}>
          {
            // ##### 23-10-04 Komarov
            Search
          }
        </button>
      </div>
    </div>
  );
};

export default BorderInnerWrapper2DivTag;
